import { render, staticRenderFns } from "./zMenuImpressoes.vue?vue&type=template&id=0f974983&scoped=true&"
import script from "./zMenuImpressoes.vue?vue&type=script&lang=js&"
export * from "./zMenuImpressoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f974983",
  null
  
)

export default component.exports